fx.ns("models", class Font extends fx.Model {

	constructor(data)
	{
        super(data);
    }
    
});
        